(function () {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');


  if (menuToggle && mobileNav) {
    const rootPanel = mobileNav.querySelector('[data-menu-root]');
    const keyringPanel = mobileNav.querySelector('[data-keyrings-panel]');
    const openKeyrings = mobileNav.querySelector('[data-keyrings-open]');
    const backButton = mobileNav.querySelector('[data-menu-back]');
    const closeButton = mobileNav.querySelector('[data-menu-close]');
    let previousOverflow = '';
    function showRoot() {
      rootPanel.hidden = false;
      keyringPanel.hidden = true;
      backButton.hidden = true;
      openKeyrings.setAttribute('aria-expanded', 'false');
    }
    function closeMenu() { mobileNav.close(); }
    menuToggle.addEventListener('click', function () {
      showRoot();
      previousOverflow = document.body.style.overflow;
      mobileNav.showModal();
      document.body.style.overflow = 'hidden';
      menuToggle.setAttribute('aria-expanded', 'true');
      openKeyrings.focus();
    });
    closeButton.addEventListener('click', closeMenu);
    mobileNav.addEventListener('close', function () {
      document.body.style.overflow = previousOverflow;
      menuToggle.setAttribute('aria-expanded', 'false');
      showRoot();
      menuToggle.focus();
    });
    mobileNav.addEventListener('click', function (event) {
      if (event.target !== mobileNav) return;
      const rect = mobileNav.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeMenu();
    });
    openKeyrings.addEventListener('click', function () {
      rootPanel.hidden = true;
      keyringPanel.hidden = false;
      backButton.hidden = false;
      openKeyrings.setAttribute('aria-expanded', 'true');
      mobileNav.scrollTop = 0;
      backButton.focus();
    });
    backButton.addEventListener('click', function () {
      showRoot();
      openKeyrings.focus();
    });
    mobileNav.querySelectorAll('a').forEach(function (link) { link.addEventListener('click', closeMenu); });
    window.matchMedia('(min-width: 900px)').addEventListener('change', function (event) { if (event.matches && mobileNav.open) closeMenu(); });
  }
  document.querySelectorAll('.moment-desktop-menu').forEach(function (details) {
    details.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { details.open = false; details.querySelector('summary').focus(); }
    });
    document.addEventListener('click', function (event) { if (!details.contains(event.target)) details.open = false; });
  });

  function syncColourPhotoNote(thumb) {
    const note = document.querySelector('[data-colour-photo-note]');
    if (!note) return;
    const selected = document.querySelector('[data-color-radio]:checked');
    const colour = selected && selected.value;
    const shown = thumb && thumb.getAttribute('data-frame-color');
    const mismatch = !!colour && (!shown || shown.toLowerCase() !== colour.toLowerCase());
    const template = note.getAttribute(shown ? 'data-colour-template' : 'data-unidentified-template') || '';
    const text = mismatch ? template.replace('__COLOUR__', colour) : '';
    if (note.textContent !== text) note.textContent = text;
    note.hidden = !mismatch;
  }

  document.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const src = thumb.getAttribute('data-full-src');
      const srcset = thumb.getAttribute('data-srcset') || '';
      const alt = thumb.getAttribute('data-alt') || '';
      const main = document.querySelector('[data-product-main-image]');
      if (!main || !src) return;
      // Must update srcset too: browsers prefer srcset over src when both exist.
      if (srcset) {
        main.setAttribute('srcset', srcset);
      } else {
        main.removeAttribute('srcset');
      }
      main.src = src;
      const imageOpen = document.querySelector('[data-image-open]');
      const imageNote = document.querySelector('[data-image-note]');
      const exampleNote = document.querySelector('[data-image-example-note]');
      if (exampleNote) exampleNote.hidden = thumb.getAttribute('data-example-image') !== 'true';
      if (imageOpen) imageOpen.href = src;
      if (imageNote) imageNote.hidden = thumb.getAttribute('data-information-image') !== 'true';
      main.alt = alt;
      syncColourPhotoNote(thumb);
      document.querySelectorAll('[data-product-thumb]').forEach(function (el) {
        el.classList.toggle('is-active', el === thumb);
        el.setAttribute('aria-pressed', String(el === thumb));
      });
    });
  });

  document.querySelectorAll('[data-color-radio]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      const group = radio.closest('.product__colors');
      const select = group && group.querySelector('[data-variant-select]');
      if (!select) return;
      select.value = radio.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      group.querySelectorAll('.color-option').forEach(function (label) {
        label.classList.toggle('is-selected', label.contains(radio) && radio.checked);
      });
    });
  });

  const packRadios = document.querySelectorAll('[data-pack-radio]');
  const packSelect = document.querySelector('[data-pack-select]');
  if (packRadios.length && packSelect) {
    packRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        packSelect.value = radio.value;
        packSelect.dispatchEvent(new Event('change', { bubbles: true }));
        document.querySelectorAll('.pack-option').forEach(function (label) {
          label.classList.toggle('is-selected', label.contains(radio) && radio.checked);
        });
      });
    });
  }

  const variantSelects = document.querySelectorAll('[data-variant-select]');
  const productForm = document.querySelector('[data-product-form]');
  const variantsNode = document.querySelector('[data-product-variants]');
  if (productForm && variantSelects.length && variantsNode) {
    let variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent || '[]');
    } catch (e) {
      variants = [];
    }
    const idInput = productForm.querySelector('[data-variant-id], [name="id"]');
    const priceEl = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-product-compare]');
    const mainImage = document.querySelector('[data-product-main-image]');
    const submitBtn = productForm.querySelector('[type="submit"]');

    function selectedOptions() {
      return Array.from(variantSelects).map(function (select) {
        return select.value;
      });
    }

    function syncVariant() {
      const options = selectedOptions();
      const match = variants.find(function (variant) {
        return variant.options.every(function (opt, i) {
          return opt === options[i];
        });
      });
      if (!match || !idInput) return;
      idInput.value = match.id;
      const priceWrap = priceEl && priceEl.closest('[data-moment-price]');
      const promotionEnd = priceWrap && Number(priceWrap.getAttribute('data-promotion-end'));
      const promotionActive = promotionEnd && Date.now() < promotionEnd * 1000;
      const displayedPrice = promotionActive ? Math.round(match.price * 0.8) : match.price;
      const displayedCompare = promotionActive ? match.price : match.compare_at_price;
      if (priceEl) {
        priceEl.textContent = formatMoney(displayedPrice);
      }
      if (priceWrap) {
        const note = priceWrap.querySelector('[data-promotion-note]');
        if (note) note.hidden = !promotionActive;
      }
      if (compareEl) {
        if (displayedCompare && displayedCompare > displayedPrice) {
          compareEl.textContent = formatMoney(displayedCompare);
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }
      showVariantGallery(match, mainImage);
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available
          ? submitBtn.getAttribute('data-add-label') || 'Aggiungi al carrello'
          : submitBtn.getAttribute('data-soldout-label') || 'Esaurito';
      }
    }

    function showVariantGallery(match, imageEl) {
      const thumbs = Array.from(document.querySelectorAll('[data-product-thumb]'));
      const colored = thumbs.some(function (thumb) {
        return (thumb.getAttribute('data-frame-color') || '').trim().length > 0;
      });
      if (!colored) {
        if (imageEl && match.featured_image && match.featured_image.src) {
          imageEl.removeAttribute('srcset');
          imageEl.src = match.featured_image.src;
          const imageOpen = document.querySelector('[data-image-open]');
          const imageNote = document.querySelector('[data-image-note]');
          if (imageOpen) imageOpen.href = match.featured_image.src;
          if (imageNote) imageNote.hidden = true;
          const exampleNote = document.querySelector('[data-image-example-note]');
          if (exampleNote) exampleNote.hidden = true;
          if (match.featured_image.alt) imageEl.alt = match.featured_image.alt;
        }
        return;
      }
      const selectedColor = String(match.option1 || '').toLowerCase();
      const matching = thumbs.filter(function (thumb) {
        return thumb.getAttribute('data-frame-color') === selectedColor;
      });
      thumbs.forEach(function (thumb) {
        const frame = (thumb.getAttribute('data-frame-color') || '').trim();
        thumb.hidden = matching.length > 0 && !!frame && frame !== selectedColor;
      });
      const wrap = document.querySelector('.product__thumbs');
      if (wrap) wrap.hidden = thumbs.filter(function (thumb) { return !thumb.hidden; }).length < 2;
      const first = matching[0] || thumbs[0];
      if (first) first.click();
      else syncColourPhotoNote(null);
    }

    variantSelects.forEach(function (select) {
      select.addEventListener('change', syncVariant);
    });
    syncVariant();
  }

  function formatMoney(cents) {
    try {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'it-IT', {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active
          ? window.Shopify.currency.active
          : 'EUR'
      });
    } catch (e) {
      return (cents / 100).toFixed(2) + ' €';
    }
  }
})();



